export default __webpack_public_path__ + "static/media/img-36.ee7dc4de.jpg";